(function () {
  'use strict';
  if (window.swDiscoveryMembershipsPilot) { window.swDiscoveryMembershipsPilot(); return; }
  var masterSelector = 'form[action*="/cart/add"] select[name="id"], form.ajax-product-form select[name="id"], select[data-product-select][name="id"]';
  function init() {
    var seen = new Set();
    document.querySelectorAll('[data-sw-memberships]').forEach(function (row) {
      var section = row.closest('[data-section-type="product"]');
      var productRoot = row.closest('.product-detail[data-product-id]');
      if (!section || !productRoot || productRoot.dataset.productId !== row.dataset.productId) { row.hidden = true; return; }
      var key = section.id + ':' + row.dataset.productId;
      if (seen.has(key)) { row.remove(); return; }
      seen.add(key);
      if (row.swMembershipSync) { row.swMembershipSync(); return; }
      var timer;
      function sync() {
        var master = productRoot.querySelector(masterSelector);
        var selected = master ? String(master.value || '') : '';
        var count = 0;
        row.querySelectorAll('[data-sw-membership]').forEach(function (chip) {
          var variant = chip.dataset.memberVariant;
          chip.hidden = !!variant && variant !== selected;
          if (!chip.hidden) count += 1;
        });
        row.hidden = count === 0;
      }
      function schedule() { clearTimeout(timer); timer = setTimeout(sync, 0); }
      row.swMembershipSync = sync;
      productRoot.addEventListener('change', schedule);
      sync();
    });
  }
  window.swDiscoveryMembershipsPilot = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('pageshow', init);
})();
